import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

	const routes = [
	{
		path: '/',
		name: 'Auth',
		component: () => import(/* webpackChunkName: "about" */ '../views/Auth.vue')
	},
	{
		path: '/groups',
		name: 'Groups',
		component: () => import(/* webpackChunkName: "about" */ '../views/Groups.vue')
	},
	{
		path: '/service_selection',
		name: 'ServiceSelection',
		component: () => import('../views/ServiceSelection.vue')
	},
	{
		path: '/segmentation_data_form',
		name: 'SegmentationDataForm',
		component: () => import('../views/SegmentationDataForm.vue')
	},
	{
		path: '/name_form',
		name: 'NameForm',
		component: () => import('../views/NameForm.vue')
	},
	{
		path: '/phone_form',
		name: 'PhoneForm',
		component: () => import('../views/PhoneForm.vue')
	},
	{
		path: '/home/:nickname',
		name: 'HomeRemote',
		component: () => import(/* webpackChunkName: "about" */ '../views/HomeRemote.vue')
	},
	{
		path: '/branch/:branchId',
		name: 'Branch',
		component: () => import(/* webpackChunkName: "about" */ '../views/Service.vue')
	},
	{
		path: '/branch/:nickname/:ticketId',
		name: 'ticketRemote',
		component: () => import(/* webpackChunkName: "about" */ '../views/HomeRemote.vue')
	},
	{ 
		path: '/select_appointment', 
		name: 'SelectAppointment', 
		component: () => import(/* webpackChunkName: "about" */ '../views/SelectAppointment.vue') 
	},
	{ 
		path: '/ticket_success', 
		name: 'TicketSuccess', 
		component: () => import(/* webpackChunkName: "about" */ '../views/TicketSuccess.vue') 
	},
	{ 
		path: '/print_success', 
		name: 'PrintSuccess', 
		component: () => import(/* webpackChunkName: "about" */ '../views/PrintSuccess.vue') 
	},
	//*********** No authentication routes ***********
	{
		path: '/branch_/:branchId',
		name: 'BranchNoAuth',
		component: () => import(/* webpackChunkName: "about" */ '../views/noAuth/Service.vue')
	},
	{
		path: '/hour_selection_',
		name: 'HourSelectionNoAuth',
		component: () => import(/* webpackChunkName: "about" */ '../views/noAuth/HourSelection.vue')
	},
	{
		path: '/segmentation_',
		name: 'SegmentationNoAuth',
		component: () => import(/* webpackChunkName: "about" */ '../views/noAuth/Segmentation.vue')
	},
	{
		path: '/form_user_',
		name: 'FormUserNoAuth',
		component: () => import(/* webpackChunkName: "about" */ '../views/noAuth/FormUser.vue')
	},
	{
		path: '/ticket_',
		name: 'TicketNoAuth',
		component: () => import(/* webpackChunkName: "about" */ '../views/noAuth/Ticket.vue')
	},
	{
		path: '/ticket_info_',
		name: 'TicketInfoNoAuth',
		component: () => import(/* webpackChunkName: "about" */ '../views/noAuth/TicketInfo.vue')
	},
	//*********** No authentication routes ***********
	{ path: '/404', component: () => import(/* webpackChunkName: "about" */ '../views/404.vue') }, 
	{ path: '/error', name: 'error', component: () => import(/* webpackChunkName: "about" */ '../views/Error.vue') },  
	{ path: '/error_na', name: 'errorNoAuth', component: () => import('../views/ErrorNoAuth.vue') },  
	{ path: '*', redirect: '/404' }, 
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
